$(document).ready(function() {
    $(".accordion-header").click(function(event) {
        event.preventDefault();
        if ($(this).parents('.actv').length) 
       	{
			$(this).parent().removeClass("actv");
		}
		else
		{
		$(this).parent().addClass("actv");
        $(this).parent().siblings().removeClass("actv");
		}
    });
});
